import {Form, Col, Button, Row} from '@deere/ux.uxframe-react'
import React from 'react'
import { useHistory } from "react-router";
import { CM_RESPONSE_STATUS,SCBM_STATES_CAMPAIGN, SCBM_USER_TYPE,CM_ADMIN, CM_IF_ADMIN } from '../../utils/surveyLiterals'
import { useTranslation } from "react-i18next";
import { useUserInfo } from '../../providers/userProvider'

export default function CMActionsPage({setShowAgreement,cmResponse,setShowValidation,campaign, setShowDeereUserConfirmation, isAuthMethodOkta}){
    const userInfo = useUserInfo();
    const history = useHistory();
    const { t } = useTranslation();    

    const submitSurveyResponses = () =>{
        if (isAuthMethodOkta !== undefined && !isAuthMethodOkta)
            setShowAgreement(true);
        else if (userInfo && (userInfo.roles.includes(CM_IF_ADMIN) || userInfo.roles.includes(CM_ADMIN)))
            setShowDeereUserConfirmation(true);
        else
            setShowAgreement(true);
    }

    const showValidation = () =>{
        setShowValidation(true)
    }

    function disableSubmitButtons(cmResponse, campaign, userInfo, isSubmit){
        if (campaign.status === SCBM_STATES_CAMPAIGN.CLOSED)
            return true;
        if (isAuthMethodOkta !== undefined && !isAuthMethodOkta)
            return false;
        const deereUser = userInfo && userInfo.userType === SCBM_USER_TYPE.SALARY && !userInfo.roles.includes(CM_IF_ADMIN) && !userInfo.roles.includes(CM_ADMIN);
        return (cmResponse.status === CM_RESPONSE_STATUS.SUBMITTED && isSubmit) || deereUser;
    }

    function disableDeleteButton(cmResponse, campaign, userInfo, isSubmit){
        if (campaign.status === SCBM_STATES_CAMPAIGN.CLOSED)
            return true;
        if (isAuthMethodOkta !== undefined && !isAuthMethodOkta)
            return false;
        return (cmResponse.status === CM_RESPONSE_STATUS.SUBMITTED && isSubmit) || ( !userInfo.roles.includes(CM_ADMIN) && !userInfo.roles.includes(CM_IF_ADMIN) );
    }


    return (<>
            <Row className="card position-sticky fixed-bottom d-print-none">
                <Row className="card position-sticky fixed-bottom">
                    <Col md="24" className="card-body p-3 text-right">
                        <Form.Group as={Col} className="align-right">  
                            <Button variant="primary" className="float-right" onClick={submitSurveyResponses} disabled={!cmResponse || disableSubmitButtons(cmResponse,campaign, userInfo, true)}>{t('btn_review_submit')}</Button>
                            <Button variant="secondary" className="float-right mr-2" onClick={e =>history.goBack()} >{t('btn_review_back_to_edit')}</Button> 
                            <Button variant="secondary" className="float-right mr-2" onClick={showValidation} disabled={!cmResponse || disableDeleteButton(cmResponse,campaign, userInfo, false)}>{t('btn_review_delete')}</Button>
                        </Form.Group>
                    </Col>
                </Row>
            </Row>             
             </>)
}   